export default "__VITE_ASSET__5tgYD$le__"